/** The server refuses to submit a purchase order or work order that would take a project over its budget (409 BUDGET_EXCEEDED).
 *  Returns that refusal's details (message, over, budget, after), or null for any other error. */
export function budgetExceeded(err) {
  const d = err?.response?.data?.detail;
  return err?.response?.status === 409 && d && typeof d === "object" && d.code === "BUDGET_EXCEEDED" ? d : null;
}
